import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const apiPrefixInterceptor: HttpInterceptorFn = (req, next) => {
  if (!/^(http|https):/i.test(req.url) && !req.url.startsWith('assets')) {
    req = req.clone({ url: environment.serverUrl + req.url });
  }
  return next(req);
};
